import React, { useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PublicIcon from '@material-ui/icons/Public';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ComplianceHeader from "./ComplianceHeader";
import { useDispatch, useSelector } from 'react-redux';
import { GET_COMPLIANCE_INITIAL_DATA } from './complianceConstants';
import Page_Loader from "../../assets/vizr_images/page_loader.gif";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 500,
    margin: '20px auto',
  },
});

export default function ComplianceTab({ activeTabProp, setActiveTab }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const initialData = useSelector(
    (state) => state.ComplianceReducer.complianceInitialData
  );
  const loader = useSelector(
    (state) => state.ComplianceReducer.complianceLoader
  );
  useEffect(() => {
    if (!initialData || !initialData.heading) {
      dispatch({ type: GET_COMPLIANCE_INITIAL_DATA });
    }
  }, []);
  let activeTab = 0;
  if (activeTabProp === 'dashboard') {
    activeTab = 1;
  } else {
    activeTab = 0;
  }
  const [value, setValue] = React.useState(activeTab);
  useEffect(() => {
    if (activeTabProp === 'dashboard') {
      activeTab = 1;
    } else {
      activeTab = 0;
    }
    setValue(activeTab);
  }, [activeTabProp]);
  const handleChange = (event, newValue) => {
    console.log('handle change newValue', newValue);
    setValue(newValue);
    if (newValue === 0) {
      setActiveTab('map');
    } else {
      setActiveTab('dashboard');
    }
  };

  const setTabColor = (index) => {
    return value === index ? '#1282B3' : 'inherit';
  }

  const renderContent = () => {
    return <>
      <Paper square className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="icon label tabs example"
        >
          <Tab
            style={{ color: setTabColor(0) }}
            icon={<PublicIcon />}
            label="MAP"
          />
          <Tab
            style={{ color: setTabColor(1) }}
            icon={<DashboardIcon />}
            label="DASHBOARD"
          />
        </Tabs>
      </Paper>
    </>
  }

  return (
    <>
      <ComplianceHeader
        title={initialData?.heading || ''}
        subtitle={initialData?.subHeading || ''}
      />
      {loader ? (
        <div className='loader-center-align'>
          <img
            src={Page_Loader}
            alt="loading"
            className="loader-img"
          ></img>
        </div>
      ) : renderContent()}
    </>

  );
}